/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ReportIdNameReference } from './reportIdNameReference';

export type SubmissionRecordCorrector = ReportIdNameReference | null;
